import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=35f0ef8a&"
import script from "./Textbox.vue?vue&type=script&lang=ts&"
export * from "./Textbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports